export const VEHICLE_REGISTOR_REQUEST = 'VEHICLE_REGISTOR_REQUEST'
export const NEW_VEHICLE_SUCCESS = 'NEW_VEHICLE_SUCCESS'
export const NEW_VEHICLE_FAIL = 'NEW_VEHICLE_FAIL'
export const VEHICLE_DETAILS_REQUEST='VEHICLE_DETAILS_REQUEST'
export const VEHICLE_DETAILS_SUCCESS='VEHICLE_DETAILS_SUCCESS'
export const VEHICLE_DETAILS_FAIL='VEHICLE_DETAILS_FAIL'
export const DELETE_VEHICLE_REQUEST='DELETE_VEHICLE_REQUEST'
export const DELETE_VEHICLE_SUCCESS='DELETE_VEHICLE_SUCCESS,'
export const DELETE_VEHICLE_FAIL='DELETE_VEHICLE_FAIL,'
export const DELETE_VEHICLE_RESET='DELETE_VEHICLE_RESET'
export const NEW_REVIEW_REQUEST = 'NEW_REVIEW_REQUEST'
export const NEW_REVIEW_SUCCESS = 'NEW_REVIEW_SUCCESS'
export const NEW_REVIEW_RESET = 'NEW_REVIEW_RESET'
export const NEW_REVIEW_FAIL = 'NEW_REVIEW_FAIL'
export const GET_REVIEWS_REQUEST = 'GET_REVIEWS_REQUEST'
export const GET_REVIEWS_SUCCESS = 'GET_REVIEWS_SUCCESS'
export const GET_REVIEWS_FAIL = 'GET_REVIEWS_FAIL'
export const DELETE_REVIEW_REQUEST = 'DELETE_REVIEW_REQUEST'
export const DELETE_REVIEW_SUCCESS = 'DELETE_REVIEW_SUCCESS'
export const DELETE_REVIEW_RESET = 'DELETE_REVIEW_RESET'
export const DELETE_REVIEW_FAIL = 'DELETE_REVIEW_FAIL'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'